import { render, staticRenderFns } from "./ToConfirm.vue?vue&type=template&id=1bcb034a&"
import script from "./ToConfirm.vue?vue&type=script&lang=js&"
export * from "./ToConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports